import React from 'react';
export function ClosingCTA() {
  return <section className="py-7 px-4 bg-brand-navy text-white" data-id="element-42">
      <div className="max-w-3xl mx-auto text-center" data-id="element-43">
        <h2 className="text-2xl md:text-4xl font-display font-bold uppercase leading-tight mb-4" data-id="element-44">
          Hay <span className="text-brand-orange" data-id="element-45">dos tipos</span> de docentes
          de Acuicultura.
        </h2>

        <div className="text-left space-y-3 text-sm md:text-base text-white/90 font-medium leading-snug" data-id="element-46">
          <p data-id="element-47">
            Los que improvisan cada semana, buscan material el domingo a la
            noche y llegan al lunes sin estar seguros de lo que van a enseñar.
          </p>
          <p className="font-bold text-white text-base md:text-lg" data-id="element-48">
            Y los que tienen un sistema.
          </p>
          <p data-id="element-49">
            La diferencia no es el conocimiento técnico. La diferencia es tener
            la arquitectura didáctica que convierte ese conocimiento en
            aprendizaje real, medible y aplicable.
          </p>
          <p data-id="element-50">
            Por <span className="text-brand-orange font-bold" data-id="element-51">ARS $21.990</span>{' '}
            tenés todo lo que necesitás para ser el segundo tipo de docente.
          </p>
          <p data-id="element-52">
            Por <span className="text-brand-orange font-bold" data-id="element-53">ARS $29.990</span>{' '}
            tenés el arsenal completo para llevar a tus mejores alumnos a un
            nivel que ningún otro material del sector puede ofrecer.
          </p>
          <p className="italic text-center pt-2" data-id="element-54">
            El docente que sus alumnos recuerdan. El docente que sus colegas le
            preguntan qué curso hizo.
          </p>
        </div>
      </div>
    </section>;
}